/* eslint-disable jsx-a11y/anchor-is-valid */
import { IllustrationView, StopWatchIllustration } from 'modules/shared/features/illustration';
import { Link } from 'react-router-dom';

const Page = () => {
    return (
        <IllustrationView
            className="mt-[18vh]"
            illustration={<StopWatchIllustration />}
            title="Page Not Found"
            message={
                <>
                    Sorry but the page you are looking for does not exist, <br /> have been removed or renamed.
                    <div className="mt-1">
                        <Link to="/" replace className="text-primary font-medium cursor-pointer">
                            Back to home
                        </Link>
                    </div>
                </>
            }
        />
    );
};

export default Page;
